"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var WarehouseKeeper = function WarehouseKeeper(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.2881 2.32928C12.5362 2.23583 12.813 2.36119 12.9065 2.60927L14.5012 6.84299C14.5947 7.09107 14.4693 7.36793 14.2212 7.46138L9.98751 9.05613C9.73943 9.14958 9.46257 9.02422 9.36912 8.77614L7.77437 4.54242C7.68092 4.29434 7.80628 4.01748 8.05436 3.92403L12.2881 2.32928ZM11.0009 5.38783C10.7209 5.49056 10.4106 5.34687 10.3079 5.06689L10.0379 4.33096L8.99655 4.72321L10.1683 7.83395L13.279 6.6622L12.1073 3.55146L11.0486 3.95024L11.3218 4.69487C11.4245 4.97486 11.2809 5.28511 11.0009 5.38783Z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.87997 4.3838C2.58173 4.3838 2.33997 4.62557 2.33997 4.9238C2.33997 5.22203 2.58173 5.4638 2.87997 5.4638H5.89611L10.6136 18.0093C9.95884 18.3406 9.50997 19.0198 9.50997 19.8038C9.50997 20.9139 10.4099 21.8138 11.52 21.8138C12.6301 21.8138 13.53 20.9139 13.53 19.8038C13.53 19.6506 13.5128 19.5013 13.4803 19.3579L21.3413 16.3788C21.6202 16.2731 21.7606 15.9613 21.6549 15.6824C21.5492 15.4036 21.2375 15.2632 20.9586 15.3688L12.963 18.399C12.9501 18.3879 12.9373 18.3768 12.9245 18.3659C12.5999 18.0488 12.1684 17.8407 11.6891 17.8008L6.77541 4.73374C6.69625 4.52321 6.49488 4.3838 6.26997 4.3838H2.87997ZM11.4613 18.8756C11.6521 18.8836 11.7782 18.9141 11.8896 18.9644C11.9783 19.0045 12.0746 19.0649 12.1939 19.1629C12.3526 19.3297 12.45 19.5554 12.45 19.8038C12.45 20.3174 12.0336 20.7338 11.52 20.7338C11.0063 20.7338 10.59 20.3174 10.59 19.8038C10.59 19.3099 10.975 18.9059 11.4613 18.8756Z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.2823 7.68299C17.1889 7.43491 16.912 7.30956 16.664 7.40301L10.3192 9.79296C10.0711 9.88641 9.94572 10.1633 10.0392 10.4113L12.4291 16.7562C12.5226 17.0042 12.7994 17.1296 13.0475 17.0361L19.3923 14.6462C19.6404 14.5527 19.7657 14.2759 19.6723 14.0278L17.2823 7.68299ZM13.893 11.2598C13.9957 11.5398 14.306 11.6835 14.586 11.5808C14.866 11.478 15.0096 11.1678 14.9069 10.8878L14.3689 9.42157L16.4832 8.62518L18.4501 13.847L13.2283 15.814L11.2613 10.5921L13.3582 9.80228L13.893 11.2598Z",
    fill: color
  }));
};
var _default = exports["default"] = WarehouseKeeper;